import axios from 'axios';
import store from '@/store'

const initialState = () => ({
  fetching: null,
  error: null,
  success: null
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    RESET_STATE(state){
      state.fetching = null
      state.error = null
      state.success = null
    },
    FETCHING(state, value){
      state.fetching = !!value;
    },
    FETCH_SUCCESS(state, value){
      state.success = !!value;
    },
    FETCH_ERROR(state, value){
      state.error = value;
    }
  },
  actions: {
    reset({ commit }){
      commit('RESET_STATE')
    },
    async activate({ commit, rootState }, args){
      commit('RESET_STATE');
      commit('FETCHING', true);

      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      };

      const params = {
        calendario_id: args.calendar.calendar_id,
      }

      try{
        const response = await axios.post(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + `inscripciones/contactos/${args.user_id}/pendientes/activar`,
          params,
          options
        );
        commit('FETCH_SUCCESS', true);
        commit('FETCHING', false);
        return response;
      }catch (err) {
        commit('FETCH_ERROR', err);
        commit('FETCHING', false);
        return err;
      }
    },
    async enroll({ commit }, args) {
      commit('RESET_STATE');
      commit('FETCHING', true);

      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      };

      const params = {
        calendario_id: args.calendar.calendar_id,
        metodo_pago_id: 10,
        pais_id: args.country_id
      }

      try {
        const response = await axios.post(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + `inscripciones/contactos/${args.user_id}/cursos`,
          params,
          options
        );

        commit('FETCH_SUCCESS', true);
        commit('FETCHING', false);
        return response.data;
      } catch (err) {
        commit('FETCH_ERROR', err);
        commit('FETCHING', false);
        return err;
      }
    },
  },
  getters: {
    fetching: (state) => state.fetching,
    error: (state) => state.error,
    success: (state) => state.success
  },
};
